import {serialize} from '../../../shared/utils/serialize-query-params';
import {notifiesApi} from '../../api';
import {createMutation} from '../../lib';

const {updateStatus} = notifiesApi.notifications;

export type PatchNotificationsMutationParams = Parameters<typeof updateStatus>[0];

export const usePatchNotificationsMutation = createMutation((params: PatchNotificationsMutationParams) =>
  updateStatus(params, {paramsSerializer: {serialize}}),
);
